/**
 * Contract between a section that mounts when it nears the viewport and the
 * full-page visual snapshots, which bring such sections into view before
 * capturing (see e2e/helpers/visual-snapshot.ts).
 */
export const MOUNTS_NEAR_VIEWPORT = {
  attribute: "data-mounts-near-viewport",
  pending: "pending",
  mounted: "mounted",
} as const;
